import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import { useLocation } from 'react-router';
import { Context } from '@routes/private/Editor/Context';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import Button from '@components/Button';
import ClickOutside from '@components/ClickOutside';
import Tabs from '@components/Tabs';
import ExportOption from './ExportOption';
import ShareOption from './ShareOption'
import { PermissionEnum } from '@state/designs/types';
import ToolTip from '@components/Tooltip';

const MENU_OPTONS =  ['EXPORT', 'SHARE'];

const MenuOptions:React.FC<IProps> = (props) => {
  const location = useLocation();  
  const [options, setOptions] = useState([MENU_OPTONS[0]]);
  const context = useContext(Context);
  const  { entityInformation, userPermission, editorStatus } = useContext(Context);  
  const { userManager, userData, userRequestAccess } = useContext(AuthContext);
  const [openOptions, setOpenOptions]= useState(false);  
  const [selectedTab, setSelectedTab] = useState<string>(MENU_OPTONS[0]);

  useEffect(() => {    
    if (userRequestAccess.email) {
      setSelectedTab(MENU_OPTONS[1]);
      setOpenOptions(true);
    }
  }, [userRequestAccess]);
  
  useEffect(() => {
    if (entityInformation) {
      if (entityInformation.entityType === "DESIGN" && userPermission === PermissionEnum.EDIT) {
        setOptions([...MENU_OPTONS]);
      }
    }
  }, [entityInformation, userPermission]);

  useEffect(()=>{
    
    if (editorStatus.sharing)
    {
      setOpenOptions(editorStatus.sharing);
      setSelectedTab(MENU_OPTONS[1])
      context.onSharing(false)

    }

  },[editorStatus.sharing])

  useEffect(()=>{
    if (!openOptions)
      context.onExporting(false,editorStatus.exportingProperties);

  },[openOptions])

  const handleOpenDealerOn = async () => {
    await userManager?.signinRedirect({ state: location });
  }

  return (                            
      <ClickOutside onClickOutside={()=> setOpenOptions(false)} style={{ padding: '10px 11px', float: 'right', width: '184px', marginRight: 53, marginLeft: 'auto'}} event={"mousedown"}>        
        { (userData?.profile?.role !== "Public" && userPermission !== PermissionEnum.NONE && userPermission !== PermissionEnum.PUBLIC_VIEW) &&
          <Button 
            label={entityInformation.entityType === "DESIGN" && userPermission === PermissionEnum.EDIT ? "EXPORT OR SHARE" : "EXPORT"}
            style={{hoverBackgroundColor: "#344a70", backgroundColor: "#19325d"}} 
            onClick={()=>setOpenOptions(!openOptions)}
            disabled={false}
            icon={"download"}
          />                      
        }
        { (userData?.profile?.role === "Public" && userPermission === PermissionEnum.PUBLIC_VIEW) &&
          <ToolTip
            tip="Log in for additional functionality"
            boxStyle={{left: "unset", right: "0px", top: "40px", width: `214px`}}
            style={{padding: `10px 16px`}}
          >
            <Button 
              label={"LOG IN"}
              style={{hoverBackgroundColor: "#344a70", backgroundColor: "#19325d", marginRight: `0px`}} 
              onClick={handleOpenDealerOn}
              disabled={false}
            />
          </ToolTip>                      
        }
          {openOptions &&
          <S.TabsContainer style={{ display: openOptions ? "flex" : "none"}}>
              <Tabs
                options={options}
                value={selectedTab ?? ""}
                setValue={setSelectedTab}
                sizes={{tabWidth: 150, barWidth: 100}}
                containerStyle={{padding: `0px 39px`, boxSizing: `border-box`}}
              />
              <S.ContentContainer>
              {selectedTab ==="EXPORT" && <ExportOption designName={props.designName} setOpenOptions={setOpenOptions}/>}
              {selectedTab ==="SHARE" && <ShareOption setOpenOptions={(open: boolean) => setOpenOptions(open)}/>}
              </S.ContentContainer>
          </S.TabsContainer>}
      </ClickOutside>
    

  );
}

export default MenuOptions;